import React, { useMemo } from 'react'
import { AboveAppProgressModalContainer } from '@components/AppProgressOverlay/AboveAppProgress/AboveAppProgress'
import { isTransferEthData } from '@towns/userops'
import { FancyButton, Icon, Stack, Text } from '@ui'
import { formatUnitsToFixedLength } from 'hooks/useBalance'
import { isTouch } from 'hooks/useDevice'
import { Address } from 'viem'

import { RecipientText } from '../UserOpTxModal/RecipientText'

import { useOpForSimpleAccount } from './hooks'

export function ConfirmationModal(props: { address: Address }) {
    const { address } = props
    const { promptUser, setPromptResponse, currOpDecodedCallData, balanceIsLessThanCost } =
        useOpForSimpleAccount(address)

    const deny = () => setPromptResponse(address, 'deny')
    const confirm = () => setPromptResponse(address, 'confirm')
    const _isTouch = isTouch()

    const toAddress = useMemo(() => {
        if (isTransferEthData(currOpDecodedCallData)) {
            return currOpDecodedCallData.toAddress
        }
    }, [currOpDecodedCallData])

    if (!promptUser || !toAddress) {
        return null
    }

    return (
        <AboveAppProgressModalContainer
            asSheet={_isTouch}
            minWidth="auto"
            padding="none"
            onHide={deny}
        >
            <Stack
                gap
                position="relative"
                background={_isTouch ? undefined : 'level2'}
                padding="md"
                width={!_isTouch ? '420' : 'auto'}
                maxWidth="420"
            >
                <Stack gap>
                    <Stack horizontal gap justifyContent="spaceBetween">
                        <Text>Sending:</Text>
                        <Stack horizontal alignItems="center" gap="xs">
                            {formatUnitsToFixedLength(currOpDecodedCallData?.value ?? 0n)} ETH
                            <Icon type="base" color="coinbaseBlue" size="square_sm" />
                        </Stack>
                    </Stack>
                    <RecipientText sendingTo={toAddress} />
                </Stack>

                {balanceIsLessThanCost ? (
                    <Stack gap horizontal background="level1" padding="md" borderRadius="md">
                        <Icon type="alert" color="error" size="square_md" />
                        <Text>
                            The balance in your wallet won&apos;t cover gas fees for this
                            transaction.
                        </Text>
                    </Stack>
                ) : (
                    <FancyButton cta onClick={confirm}>
                        Confirm
                    </FancyButton>
                )}
            </Stack>
        </AboveAppProgressModalContainer>
    )
}
